import React, { useEffect, useState } from "react";
import { Box, Card, Divider, TableBody } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Paginator from "../../../toolkit/Paginator";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import axios from "../../../utils/fvAxios";
import BaseUrl from "../../../utils/base-uri.json";
import { isArray } from "lodash";
import _ from "lodash";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import { KeyboardArrowDown, KeyboardArrowUp, UnfoldMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Status from "../../../stories/StatusComponent/status.json";
import debounce from 'lodash/debounce';

const queryUrl = BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetOffsiteEmployees;
const pageSize = 10;

const toQueryString = (obj) => {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
};

const getUrl = (url, data) => `${url}${toQueryString(data)}`;

export default function VendorEmployees({
  businessUnitId,
  locationId,
  clientId,
  hasBadgePermission,
  hasPermission
}) {
  const navigate = useNavigate();
  const handleClick = (event, vendorID) => {
    axios.get(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetPrequalificationDetail + "?vendorID=" + vendorID)
      .then((response) => {
        if (response?.data?.responseCode === 100) {
          // navigate("/vendordetails?pqid=" + response?.data?.data?.prequalificationId);
          if (event.ctrlKey) {

            window.open("/GetClientEmployees?Vendor=" + response?.data?.data?.vendorID + "&Client=" + response?.data?.data?.clientId + "&pqId=" + response?.data?.data?.prequalificationId, "_blank");

          } else {
            window.location = "/GetClientEmployees?Vendor=" + response?.data?.data?.vendorID + "&Client=" + response?.data?.data?.clientId + "&pqId=" + response?.data?.data?.prequalificationId;
          }
          // navigate("/GetClientEmployees?Vendor=" + response?.data?.data?.vendorID + "&Client=" + response?.data?.data?.clientId + "&pqId=" + response?.data?.data?.prequalificationId);
        }
      }).catch((err) => setError(err));
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      marginBottom: "20px",
    },
  }));

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [Searchdebounce, setSearchdebounce] = useState("");
  const [orderBy, setOrderBy] = useState({
    sortingColumn: "VendorName",
    sortAscending: true,
  });

  const [paramsState, setParamsState] = useState({
    pageSize: pageSize,
    pageNumber: pageNumber,
    buId: businessUnitId,
    locId: locationId,
    userType: 1,
    search: searchValue,
    orderBy: orderBy.sortingColumn,
    sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
  });

  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [vendorEmployees, setVendorEmployees] = useState(null);
  const [pqStatusesFetched, setPqStatusesFetched] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({
    vendorId: null,
    empId: null,
  });
  const [tagNumber, setTagNumber] = useState();
  const [badgeNumber, setBadgeNumber] = useState();
  const [isTagDisabled, setIsTagDisabled] = useState(false);
  const [isBadgeDisabled, setIsBadgeDisabled] = useState(false);

  const handleClickOpen = (vendorId, empId, tagNumber, badgeNumber) => {
    // if (tagNumber) {
    //   setIsTagDisabled(true);
    //   setTagNumber(tagNumber);
    // }
    // if (badgeNumber) {
    //   setIsBadgeDisabled(true);
    //   setBadgeNumber(badgeNumber);
    // }
    setSelectedVendor({ vendorId, empId });
    setOpen(true);
  };
  // const WithoutPermissions = (vendorId, empId) => {
  //   setSelectedVendor({ vendorId, empId });
  //   chekcinEmployee();
  // };
  const handleClose = () => {
    setOpen(false);
    setSelectedVendor({ vendorId: null, empId: null });
    setTagNumber(undefined);
    setIsTagDisabled(false);
    setBadgeNumber(undefined);
    setIsBadgeDisabled(false);
  };

  const chekcinEmployee = (ID, VID, EID) => {
    const { vendorId, empId } = selectedVendor;
    const data = {
      vendorEmployeeID: ID == 1 ? EID : empId,
      vendorID: ID == 1 ? VID : vendorId,
      clientBusinessUnitID: businessUnitId,
      clientBusinessUnitSiteID: locationId,
      tagNumber: tagNumber,
      badgeNumber: badgeNumber,
      userType: 1,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckinUser, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh(true);
        }
      })
      .finally(() => {
        handleClose();
      });
  };

  const getPqStatus = async (vendorId) => {
    const resp = await axios.get(
      BaseUrl.baseUrl +
      BaseUrl.OnsiteOffsite.GetPQStatus +
      "clientid=" +
      clientId +
      "&vendorid=" +
      vendorId
    );
    return resp?.data?.data?.prequalificationStatusId;
  };

  useEffect(() => {
    if (refresh) {
      if (searchValue === Searchdebounce) {
        setLoading(true);

        const url = getUrl(queryUrl, { ...paramsState });
        axios
          .get(url)
          .then((res) => {
            if (res?.data?.responseMessage === "Success") {
              const vendorEmployees = res?.data?.data;
              setPageCount(Math.ceil((res?.data?.count || pageSize) / pageSize));
              const categorizedData = Object.entries(
                vendorEmployees?.reduce((group, product) => {
                  const { vendorName } = product;
                  group[vendorName] = group[vendorName] ?? [];
                  group[vendorName].push(product);
                  return group;
                }, {})
              );
              setPqStatusesFetched(false);
              setVendorEmployees(categorizedData);
            } else {
              setError(res?.data?.responseMessage);
            }
          })
          .catch((err) => setError(err))
          .finally(() => {
            setLoading(false);
            setRefresh(false);
          });
      }
    }
  }, [paramsState, refresh, searchValue, Searchdebounce]);

  useEffect(() => {
    const fetchPqStatus = async () => {
      if (!pqStatusesFetched && vendorEmployees) {
        setPqStatusesFetched(true);

        const updatedVendorEmployees = await Promise.all(
          vendorEmployees.map(async ([vendorName, products]) => {
            const vendorId = products[0]?.vendorID;

            if (vendorId !== undefined) {
              const pqStatus = await getPqStatus(vendorId);
              const updatedVendorName = `${vendorName} + ${pqStatus}`;
              return [updatedVendorName, products];
            } else {
              return [vendorName, products];
            }
          })
        );

        setVendorEmployees(updatedVendorEmployees);
      }
    };

    fetchPqStatus();
  }, [pqStatusesFetched, vendorEmployees]);

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      buId: businessUnitId,
      locId: locationId,
      pageNumber: 1,
    }));
    setPageNumber(1);
    setRefresh(true);
  }, [locationId]);

  // const debouncedSearch = debounce((value) => {
  //   setParamsState((prev) => ({
  //     ...prev,
  //     search: value,
  //     pageNumber: 1,
  //   }));
  //   setRefresh(true);
  // }, 1000);

  // const changeSearchValue = (value) => {
  //   if (searchValue !== value) {
  //     setSearchValue(value);
  //     debouncedSearch(value);
  //   }
  // };
  const delayedSearch = debounce((value) => {
    setSearchdebounce(value)
    setParamsState((prev) => ({
      ...prev,
      search: value,
      pageNumber: 1,
    }));
    setRefresh(true);
  }, 2000);

  const changeSearchValue = (e) => {
    const { value } = e.target;
    setSearchValue(value);
    delayedSearch(value);
  };

  const changeTagNumber = (value) => {
    const numericInput = value.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setTagNumber(numericInput);
    else setTagNumber(numericInput.substring(0, 4));
  };

  const changeBadgeNumber = (value) => {
    const numericInput = value.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setBadgeNumber(numericInput);
    else setBadgeNumber(numericInput.substring(0, 4));
  };

  const setPage = (pageNumber) => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber);
      setParamsState((prev) => ({ ...prev, pageNumber }));
      setRefresh(true);
    }
  };

  const sortTable = (sortingColumn) => {
    if (orderBy.sortingColumn === sortingColumn) {
      setOrderBy((prev) => ({
        ...prev,
        sortAscending: !orderBy.sortAscending,
      }));
    } else {
      setOrderBy({
        sortingColumn,
        sortAscending: true,
      });
    }
  };

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      orderBy: orderBy.sortingColumn,
      sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
    }));
    setRefresh(true);
  }, [orderBy]);

  const textseparation = (value) => {
    const a = value?.split('+');
    return (
      <span >{a[0]} - <span style={{ color: Status?.find((r) => r?.value == a[1])?.color }}>{Status?.find((r) => r?.value == a[1])?.key}</span></span> //{a[1]}
    )

  };
  return (
    <>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          ></DialogTitle>
          <DialogActions>
            <div>
              <div>
                {hasPermission && <div>
                  <span style={{ color: "#3E4A62" }}>Tag Number </span>
                  <br />
                  <TextField
                    placeholder="Tag Number"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      fontFamily: "Arial, FontAwesome",
                    }}
                    variant="outlined"
                    size="small"
                    value={tagNumber}
                    disabled={isTagDisabled}
                    onChange={(e) => changeTagNumber(e.target.value)}
                  />
                </div>}

                {hasBadgePermission && (
                  <div className="mt-3">
                    <span style={{ color: "#3E4A62" }}>Badge Number</span>
                    <br />

                    <TextField
                      placeholder="Badge Number"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={badgeNumber}
                      disabled={isBadgeDisabled}
                      onChange={(e) => changeBadgeNumber(e.target.value)}
                    />
                  </div>
                )}
              </div>

              <DialogActions>
                <div className="login-help__buttonContainer mt-4">
                  <Button
                    variant="contained"
                    className="login-help-button-cancel mx-2"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className="login-button-request mx-2"
                    onClick={chekcinEmployee}
                  >
                    Submit
                  </Button>
                </div>
              </DialogActions>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Card>
        <div style={{ marginLeft: "10px", padding: "10px", color: "red" }}>
          This tab is for checking employees Onsite only. All employees of
          contractors working at your location are listed here. To check an
          employee's Onsite, select the <br></br> Onsite radio button. The name
          will disappear. (Some users will see a popup window to enter a tag
          and/or badge number. After clicking "Submit," the name will <br></br>{" "}
          disappear.)
        </div>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "2px",
          }}
        />
        <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
          <TextField
            placeholder="Search"
            value={searchValue}
            onChange={changeSearchValue}
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
              fontFamily: "Arial, FontAwesome",
            }}
            variant="outlined"
            size="small"
          />
        </div>
        <Box sx={{ backgroundColor: "#f8f9fa" }}>
          {loading ? (
            <LoadingSpinner />
          ) : vendorEmployees?.length > 0 ? (
            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell onClick={() => sortTable("VendorName")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Employee Name
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "VendorName" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell
                      onClick={() => sortTable("PassedOrientation")}
                    >
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Pass Orientation
                      </span>
                      <IconButton>
                        {orderBy.sortingColumn === "PassedOrientation" ? (
                          orderBy.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Onsite
                      </span>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                {vendorEmployees?.map((r, i) => (
                  <>
                    <TableHead key={i}>
                      <TableRow>
                        <StyledTableCell>
                          <span style={{ color: "#667085", fontSize: "15px" }}>
                            {textseparation(r[0])}
                          </span>
                        </StyledTableCell>
                        <StyledTableCell>&nbsp;</StyledTableCell>
                        <StyledTableCell>&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>

                    {r[1]?.map((r, index) => (
                      <TableBody key={index}>
                        <TableRow key={index}>
                          <StyledTableCell sx={{ width: "34%" }}>
                            <span
                              className="text-primary cursor-pointer"
                              onClick={(event) =>
                                handleClick(event, r.vendorID)
                              }>

                              {r.lastName + ", " + r.firstName}
                            </span>

                          </StyledTableCell>
                          <StyledTableCell sx={{ width: "32%" }}>
                            <span
                              style={{
                                fontSize: "14px",
                                color:
                                  r.passedOrientation == "No"
                                    ? "#EE3F3F"
                                    : "#12B76A",
                              }}
                            >
                              {r.passedOrientation}
                            </span>
                          </StyledTableCell>

                          <StyledTableCell sx={{ width: "20%" }}>
                            <IconButton
                              aria-label="OpenArrow"
                              onClick={() => {
                                hasPermission == false && hasBadgePermission == false ?
                                  chekcinEmployee(
                                    1,
                                    r.vendorID,
                                    r.employeeID)
                                  : handleClickOpen(
                                    r.vendorID,
                                    r.employeeID,
                                    r.oldTagId === 0 ? undefined : r.oldTagId,
                                    r.oldBadgeId === 0 ? undefined : r.oldBadgeId
                                  )
                              }
                              }
                            >
                              <span>
                                {" "}
                                <img
                                  src={RightArrowOpen}
                                  alt="OpenArrow"
                                  style={{ width: "20px" }}
                                />{" "}
                                <span
                                  style={{
                                    color: "#2A93DB",
                                    fontSize: "initial",
                                  }}
                                >
                                  Onsite
                                </span>{" "}
                              </span>
                            </IconButton>
                          </StyledTableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                  </>
                ))}
              </Table>
            </TableContainer>
          ) : error ? (
            <ErrorAlert message={error} />
          ) : (
            <ErrorAlert severity="warning" message={"No results found!"} />
          )}
        </Box>
      </Card>

      {!loading && vendorEmployees?.length > 0 && (
        <Paginator
          count={pageCount}
          page={Number(pageNumber)}
          margin="18px 0px"
          onChange={setPage}
        />
      )}
    </>
  );
}
